export enum FilterOptionsEndpoint {
  TransportManagement = '/transport-management',
  AutomotiveAftermarket = '/automotive-aftermarket',
  Filters = '/filters',
  Search = '/search',
  InboundPlants = '/inbound-plants',
  Plants = '/plants',
  Gates = '/gates',
  SapIds = '/sap-ids',
  Shipments = '/shipments',
  BusinessUnits = '/business-units',
  NetworkParts = '/networkParts',
  Consignors = '/consignors',
  FreightPayers = '/freight-payers',
  SourceLocations = '/locations/source',
  DestinationLocations = '/locations/destination',
  Abbreviations = '/abbreviations',
  SapSystems = '/sap-systems',
}
